import { Image, Typography } from "antd";
import AppImages from "assets/appImages";
import { motion } from "framer-motion";

const { Title, Paragraph } = Typography;

const TermsPage = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="h-[100dvh] overflow-y-auto bg-white px-6 pt-8 lg:px-24"
    >
      <motion.section
        className="my-4 mx-auto text-center"
        initial={{ opacity: 0, y: 60 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4 }}
      >
        <Image src={AppImages.Logo} alt="eN-LIS Logo" width={50} />
        <Title level={3}>Terms and Condition</Title>
        <Paragraph
          style={{ fontSize: "0.9rem", color: "#4B5563", lineHeight: 1.8 }}
        >
          Lorem ipsum dolor, sit amet consectetur adipisicing elit. Laboriosam
          dolorum ab reiciendis iusto, veritatis voluptate. Quidem
          asperioresptate labore asperiores, quidem iusto? Et minus enim omnis
          odio? Possimus itaque eum iure maiores, aspernatur nobis hic fugit
          veniam architecto dolore culpa. Enim beatae esse recusandae dolore est
          hic eaque iusto? Cum nesciunt autem consectetur labore excepturi
          deserunt nobis sint et laudantium mollitia architecto nemo inventore,
          vitae, neque illum voluptatem, corporis repellat similique aut
          officiis tempore. Debitis rerum ad offolorum ab reiciendis iusto,
          veritatis voluptate. Quidem asperioresptate labore asperiores, quidem
          iusto? Et minus enim omnis odio? Possimus itaque eum iure maiores,
          aspernatur nobis hic fugit veniam architecto dolore culpa. Enim beatae
          esse recusandae dolore est hic eaque iusto? Cum nesciunt autem
          consectetur labore excepturi deserunt nobis sint et laudantium
          mollitia architecto nemo inventore, vitae, neque illum voluptatem,
          corporis repellat similique aut officiis tempore. Debitis rerum ad
          officiis magni tenetur eius vel distinctio, assumenda ullam voluptates
          exercitationem quod, odit aspernatur doloremque praesentium cum sit!
          At quisquam fuga laborum eum aut architecto tempora quaerat ratione
          corporis consequatur placeat voluptas quas autem officiis dolores
          quod, nisi saepe sapiente! Temporibus velit earum culpa deleniti qui
          maxime laboriosam, laborum accusamus nam laudantium, sit labore vitae,
          quo ut assumenda est ipsam. Dolores consequatur aperiam amet debitis?
          Tenetur ducimus sunt, assumenda minus molestias eaque illo deleniti
          hic labore dolor nesciunt commodi cumque ut atque voluptatibus enim
          necessitatibus maiores harum! Unde illum praesentium velit doloribus
          perspiciatis aspernatur consectetur numquam vero accusamus? Sit
          reiciendis ab nihil vero! Molestiae delectus suscipit beatae nemo
          quibusdam at, eveniet eum itaque repellat quod odio non architecto
          dicta dolorum repellendus aspernatur laboriosam odit blanditiis, alias
          minus quo? Tempora quo accusamus sapiente voluptates tenetur eos, vero
          ut, eaque possimus similique eveniet doloremque ullam ratione
          doloribus reprehenderit, natus autem? Eos voluptate id distinctio quo
          aperiam. Asperiores mollitia dicta autem accusantium fuga minima
          maiores ex. Sequi, numquam reiciendis beatae cupiditate voluptates,
          laboriosam itaque voluptate officiis consequatur quisquam, quo
          architecto fugit illo iure ipsa temporibus aut aliquid ex rerum saepe
          blanditiis assumenda veniam. Laborum, consequuntur, nemo sed qui illum
          sit deserunt autem fugit, ipsum quam officiis soluta doloribus
          voluptatibus voluptate voluptatem repudiandae et? Perferendis officia,
          magni, dolorum nobis voluptas repellat adipisci, beatae harum
          obcaecati optio reiciendis nisi dicta quis labore sed saepe hic
          consectetur natus sapiente accusantium ad eveniet. Repudiandae ratione
          fugiat accusantium officiis ut praesentium rem id placeat mollitia
          doloribus quos iste aliquam, voluptatibus cupiditate! Nihil itaque
          nisi labore iure placeat facere, necessitatibus nostrum! Eveniet ea
          delectus error inventore sint tempore dolor ratione impedit quam est.
          Illo adipisci ratione quod quasi provident accusantium laborum
          exercitationem veritatis fugiat dolorem. Voluptate, error minus
          adipisci facilis id fugiat aspernatur rem veritatis eaque dolorum,
          perferendis ipsa vitae sunt nemo vel aliquid temporibus illo eligendi,
          ipsum veniam culpa amet voluptates! Accusantium iste facilis eveniet
          itaque reprehenderit esse necessitatibus expedita assumenda. Magnam
          similique saepe soluta reprehenderit debitis quasi natus amet eaque
          cumque qui! Architecto, iusto ab? Non impedit ex nemo, cum quas
          similique! Laborum, blanditiis! Distinctio sint doloremque non
          similique nihil! Placeat obcaecati et voluptates repudiandae a
          doloribus ut, explicabo amet iure in incidunt iste, provident saepe
          porro eaque, ratione fugit quas vitae ipsam consectetur quibusdam
          aperiam. Quibusdam dignissimos magni distinctio dolores cumque,
          praesentium atque natus modi quae delectus. Qui labore odit aperiam,
          saepe perferendis a sit, velit iure provident iusto quo fugiat
          corporis quis magnam dolores quod expedita sequi at voluptates? Atque
          iste error magnam repellendus possimus, officia exercitationem
          similique at quaerat culpa. Unde minus sunt quasi accusamus nesciunt
          dignissimos voluptatum consequatur, beatae a, repellendus,
          exercitationem mollitia nisi dicta. Neque molestiae odio debitis
          reprehenderit labore quisquam voluptas blanditiis fuga eum molestias
          beatae ullam ratione, mollitia qui laboriosam vel eos in maxime
          voluptate doloribus. Alias, optio quas? Rerum illum fugit modi quia,
          tempore aliquid voluptatem beatae accusantium aperiam similique, quasi
          recusandae. Cum autem ullam necessitatibus fugiat ea modi alias
          placeat. Facilis tenetur debitis temporibus natus ex ut, ea officiis
          itaque assumenda odio repellendus vero tempore tempora, voluptates
          praesentium error minus ab quis quasi? Corrupti dolorem, facere
          quisquam sit distinctio corporis neque qui nisi suscipit asperiores,
          assumenda magnam praesentium? Sint facere sed pariatur esse officiis
          laboriosam culpa provident iure quia ipsam minus odio labore
          voluptatem molestiae necessitatibus earum sunt, excepturi illo quaerat
          veniam optio. Dignissimos, sint, illum minus obcaecati culpa voluptas
          at consequuntur quo veritatis beatae labore nobis quas ea alias eos
          officiis doloremque repellat molestias quia nostrum! Cumque repellat,
          adipisci quod ut in maxime ea inventore debitis dolorum! Cum numquam
          fugit placeat debitis facilis nihil, ipsa accusamus eum excepturi,
          cupiditate sint ut error. Amet tempore beatae autem aut, in
          dignissimos deserunt accusamus minus ipsa hic suscipit praesentium vel
          nihil cupiditate. Dicta ut, maxime delectus, doloribus eos libero
          culpa natus deserunt dolor itaque mollitia enim? Mollitia provident ab
          incidunt voluptatibus ipsum ipsa rerum praesentium. Accusamus dolor
          deleniti rerum itaque repudiandae dolorum aperiam suscipit incidunt.
          Numquam vel quo ipsa. Quibusdam laboriosam necessitatibus voluptatem
          laudantium voluptas non odit! Molestias, necessitatibus molestiae
          illum sint tempore dolore porro placeat,
        </Paragraph>
      </motion.section>

      <motion.div
        className="mt-16 text-center"
        initial={{ opacity: 0, y: 60 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
      >
        <footer className="w-full text-center py-8 px-4 bg-gray-50 border-t text-gray-600 text-sm">
          <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 text-left">
            {/* Company Info */}
            <div>
              <h4 className="font-semibold text-gray-800 mb-2">About eN-LIS</h4>
              <p className="text-sm">
                A modern Electronic National Laboratory Information System for
                streamlining health data workflows in Nigeria.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-semibold text-gray-800 mb-2">Quick Links</h4>
              <ul className="space-y-1">
                <li>
                  <a href="/signin" className="hover:underline !text-green-700">
                    Launch App
                  </a>
                </li>
                <li>
                  <a href="/" className="hover:underline !text-green-700">
                    Home
                  </a>
                </li>
                <li>
                  <a href="/docs" className="hover:underline !text-green-700">
                    Documentation
                  </a>
                </li>
                <li>
                  <a href="/terms" className="hover:underline !text-green-700">
                    Terms of Service
                  </a>
                </li>
              </ul>
            </div>

            {/* Partners */}
            <div>
              <h4 className="font-semibold text-gray-800 mb-2">Partners</h4>
              <ul className="space-y-1">
                <li>
                  <a
                    href="https://gghnigeria.org/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline !text-green-700"
                  >
                    Georgetown Global Health Nigeria (GGHN)
                  </a>
                </li>
                <li>
                  <a
                    href="https://ncdc.gov.ng/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline !text-green-700"
                  >
                    NCDC
                  </a>
                </li>
              </ul>
            </div>

            {/* Contact / Follow */}
            <div>
              <h4 className="font-semibold text-gray-800 mb-2">Contact</h4>
              <ul className="space-y-1">
                <li>
                  <a
                    href="mailto:support@en-lis.com"
                    className="hover:underline !text-green-700"
                  >
                    support@en-lis.com
                  </a>
                </li>
                <li>
                  <a
                    href="https://gitlab.com/en-lis"
                    target="_blank"
                    className="hover:underline !text-green-700"
                  >
                    contribute
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Divider */}
          <div className="border-t mt-8 pt-4">
            <p className="text-xs text-gray-400">
              &copy; {new Date().getFullYear()} eN-LIS. Built by
              <a
                href="https://gghnigeria.org/"
                target="_blank"
                rel="noopener noreferrer"
                className="ml-1 underline !text-green-700"
              >
                Georgetown Global Health Nigeria (GGHN)
              </a>
              . All rights reserved.
            </p>
          </div>
        </footer>
      </motion.div>
    </motion.div>
  );
};

export default TermsPage;
